/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */

import moment from 'moment-timezone';
import { memo, useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { getTrustTableData } from '../../../../api/trust';
import { Button, DatePicker, Select } from '../../../../common/components';
import { useSetLoading } from '../../../../common/hooks/appearance';
import { pastDuration } from '../../../../constants/reports';
import { dateFormat } from '../../../../utils/constant';
import * as handlers from '../../../../utils/handlers';

const initialFilters = {
  trustType: null,
  needType: null,
  reportType: null,
  page: 1,
  limit: 5,
  filterType: null,
  duration: null,
};
const GenerateTrust = ({
  title,
  description,
  setShowTable,
  trustType,
  needType,
  contractType,
  monthlyReport,
  reportTypes,
  onGenerateClick,
}) => {
  const [filters, setFilters] = useState(initialFilters);
  const [loading, setLoading] = useState(false);
  const [date, _setDate] = useState(null);
  const [fromDateRange, setFromDateRange] = useState(null);
  const [toDateRange, setToDateRange] = useState(null);
  const [dateRangeDisabled, setDateRangeDisabled] = useState(false);
  const [dateValidator, setDateValidator] = useState('');
  const handleFilters = (filterType, value) => {
    if (filterType === 'trustType') {
      setFilters((prevFilters) => ({
        ...prevFilters,
        [filterType]: value,
        duration: null,
        fromDateRange: null,
        toDateRange: null,
        date: null,
      }));
    } else {
      setFilters((prevFilters) => ({
        ...prevFilters,
        [filterType]: value,
      }));
    }
  };

  const dateOptionsGenerator = (type) => {
    const options = {
      minDate: '',
      maxDate: '',
      dateFormat: dateFormat.D_M_Y,
    };
    if (type === 'toDate') {
      options.minDate = fromDateRange ? moment(fromDateRange)._d : null;
    }
    options.maxDate = new Date();
    if (toDateRange && type === 'fromDate') {
      options.minDate = null;
    }
    return options;
  };

  const generateTable = async () => {
    // formatting date asper the backend
    const fromDate = moment(fromDateRange).format(dateFormat.YEAR_MONTH_DAY);
    const toDate = moment(toDateRange).format(dateFormat.YEAR_MONTH_DAY);
    const reportDate = moment(date).format(dateFormat.YEAR_MONTH_DAY);
    const reportType = filters?.reportType?.value;

    const requestParams = {
      ...filters,
      startDate: fromDate,
      endDate: toDate,
      timezone: moment.tz.guess(),
      trustType,
      needType,
      contractType,
      search: undefined,
      reportType,
    };
    setLoading(true);
    try {
      if (!onGenerateClick) {
        const response = await getTrustTableData({
          ...requestParams,
        });

        const { data } = response || {};
        const { result, totalCount } = data || {};
        const agreementId = result?.length ? result[0].agreementId : undefined;
        const isCancelledContract = result?.length
          ? result[0]?.Agreement?.status?.toLowerCase() === 'cancelled'
          : false;

        setShowTable((state) => {
          const obj = {
            ...state,
            show: true,
            tableName: reportType,
            tableData: result || [],
            date: reportDate,
            fromDate,
            toDate,
            totalResults: totalCount || 0,
            dynamicHeaders: [],
            trustType,
            needType,
            reportType,
            contractType,
            search: undefined,
            isSearchResult: false,
          };

          obj.agreementId = agreementId;
          obj.isCancelledContract = isCancelledContract;

          return obj;
        });
        setLoading(false);
      } else {
        onGenerateClick(fromDate, toDate, reportType);
      }
    } catch (error) {
      setLoading(false);
      handlers.apiErrorHandler(error);
    }
  };

  const validateDate = (fromDate, toDate) => {
    const diffInDays = Math.round(Math.abs((fromDate - toDate) / (24 * 60 * 60 * 1000)));
    if (monthlyReport && diffInDays > 31) {
      setDateValidator('Date Range should be Max 31 days.');
    } else {
      setToDateRange(toDate);
      setDateValidator('');
    }
  };

  const validateForm = () => {
    if (filters?.filterType === 1) {
      return !date;
    }
    if (monthlyReport && dateValidator === 'Date Range should be Max 31 days.') {
      return true;
    }
    return !(fromDateRange && toDateRange);
  };

  const setDateRange = (selectedDuration) => {
    if (selectedDuration === 'custom') {
      setDateRangeDisabled(false);
      setFromDateRange(null);
      setToDateRange(null);
    } else {
      const { startDate, endDate } = handlers.getStartDateEndDate(selectedDuration);
      setFromDateRange(startDate);
      setToDateRange(endDate);
      setDateRangeDisabled(true);
    }
  };

  useEffect(() => {
    if (fromDateRange && toDateRange) {
      validateDate(fromDateRange, toDateRange);
    }
  }, [toDateRange, fromDateRange, validateDate]);

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);
  return (
    <Row className="generate-trust">
      <Col lg={6} className="generate-trust-item">
        <Row>
          <Col
            lg={filters?.filterType === 1 ? 9 : monthlyReport?.length > 0 ? 6 : 8}
            className="generate-label"
          >
            <h1 className="trust-heading">{title}</h1>
            <p className="trust-description">{description}</p>
          </Col>
          {!monthlyReport?.length && (
            <Col lg={4} className="Duration-label">
              <Select
                required
                name="duration"
                formInput={false}
                classNamePrefix="select-dropdown"
                placeholder="Duration"
                label="DURATION"
                onChange={(val) => {
                  handleFilters('duration', val);
                  setDateRange(val.value);
                }}
                value={filters.duration}
                options={pastDuration}
                size="lg"
              />
            </Col>
          )}
          {monthlyReport?.length && (
            <Col lg={6} className="Duration-label">
              <Select
                required
                name="monthlyReportType"
                formInput={false}
                classNamePrefix="select-dropdown"
                placeholder="Select"
                label="MONTHLY REPORT"
                options={reportTypes}
                onChange={(val) => {
                  handleFilters('reportType', val);
                  handleFilters('duration', JSON.parse(JSON.stringify({ value: 'custom' })));
                }}
                size="lg"
              />
            </Col>
          )}
        </Row>
      </Col>
      <Col lg={6}>
        <Row className="generate-card-item1">
          <Col lg={4} className="date-picker-g">
            <DatePicker
              name="enter date"
              required={filters?.duration?.value === 'custom'}
              formInput={false}
              placeholder="Date"
              value={fromDateRange}
              onChange={([selectedDate]) => {
                setFromDateRange(selectedDate);
              }}
              options={dateOptionsGenerator('fromDate')}
              label="FROM"
              kind="md"
              disabled={!filters?.duration?.value || dateRangeDisabled}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
            />
          </Col>
          <Col lg={4} className="date-picker-g">
            <DatePicker
              name="enter date"
              required={filters?.duration?.value === 'custom'}
              formInput={false}
              placeholder="Date"
              value={toDateRange}
              onChange={([selectedDate]) => {
                setToDateRange(selectedDate);
              }}
              options={dateOptionsGenerator('toDate')}
              label="TO"
              kind="md"
              disabled={!filters?.duration?.value || !fromDateRange ? true : dateRangeDisabled}
            />
            <p style={{ color: 'red' }}>{dateValidator}</p>
          </Col>

          <Col
            lg={filters?.filterType === 1 ? 8 : 4}
            className={filters?.filterType === 1 ? 'generate-button' : 'generate-button-1'}
          >
            <Button onClick={generateTable} disabled={validateForm()} color="primary">
              Generate
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default memo(GenerateTrust);
